import { PaymentActionsController } from "./payment-actions.controller";
import { CreateLinkPaymentDialogController } from "../link-payment-dialog/create.controller";
import { UpdateLinkPaymentDialogController } from "../link-payment-dialog/update.controller";
import "../item-bids-dialog/item-bids-trigger.component";
import "../link-payment-dialog/link-payment-dialog-items.component";

angular
    .module("thor.online-containers.edit.payment-actions.component", [
        "thor.online-containers.edit.item-bids-trigger.component",
        "thor.online-containers.edit.link-payment-dialog-items.component"
    ])
    .component("paymentActions", {
        bindings: {
            containerEndDate: "<",
            containerId: "<",
            contractId: "<",
            getItems: "&",
            isSlipPaid: "<",
            itemId: "<?",
            lastBidder: "<",
            payments: "<",
            saleCurrency: "<",
            saleDepositAmount: "<",
            salePaymentDeposit: "<"
        },
        controller: PaymentActionsController,
        template: require("./payment-actions.html")
    })
    .controller("CreateLinkPaymentDialogController", CreateLinkPaymentDialogController)
    .controller("UpdateLinkPaymentDialogController", UpdateLinkPaymentDialogController);
